import React, { useState } from "react";
import "./ChatInput.css";
import PaperClip from "Media/icons/Icon open-paperclip.svg";
import SendIcon from "Media/icons/Iconly-Bold-Send.svg";
import excelDocument from "Media/icons/excelDocument.png";
import pdfDocument from "Media/icons/pdfDocument.png";
import pptDocument from "Media/icons/pptx.png";
import { toast } from "react-toastify";
import useIsStorageLimitReached from "Hooks/useIsStorageLimitReached";
import videoFile from "Media/icons/videoFile.png";
import wordDocument from "Media/icons/wordDocument.png";

const ChatInput = ({
  onSend,
  onMediaSend,
  location,
  setShowStorageLimitReachedPopup,
}) => {
  const isStorageLimitReached = useIsStorageLimitReached();

  const [message, setMessage] = useState("");
  const [media, setMedia] = useState("");

  const resetMessage = () => {
    setMessage("");
    document.getElementById("textarea-id").value = "";
  };

  const resetMedia = () => {
    setMedia("");
  };

  const renderFileImage = () => {
    if (!media) return null;

    switch (media?.name?.split(".").at(-1)) {
      case "doc":
      case "docx":
        return wordDocument;
      case "xls":
      case "xlsx":
      case "csv":
        return excelDocument;
      case "pdf":
        return pdfDocument;
      case "ppt":
      case "pptx":
        return pptDocument;
      case "mp4":
      case "mkv":
      case "webm":
        return videoFile;
      default:
        return URL.createObjectURL(media);
    }
  };
  return (
    <>
      <div className="chat-screen-inputsection">
        <div className="chat-screen-input">
          <div className="chat-screen-input-inner">
            <textarea
              id="textarea-id"
              rows="2"
              placeholder="Type a message"
              value={message}
              // onKeyDown={(e) => {
              //   if (e.key === "Enter") {
              //     e.preventDefault();
              //     setMessage((prev) => prev + "&*&");
              //   }
              // }}
          
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            ></textarea>

            {media && (
              <div className="preview-image">
                <div className="image-cancel" onClick={resetMedia}>
                  ×
                </div>
                <img src={renderFileImage()} alt="media" />
              </div>
            )}
          </div>

          {!location && (
            <label htmlFor="image" className="attach-icon">
              <img src={PaperClip} alt="Attachment" />
              <input
                type="file"
                id="image"
                hidden
                accept="image/*,.pdf,.docx,.doc,.xlsx,.xls,.csv,.mp4,.ppt,.pptx"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  const size = file.size;
                  if (isStorageLimitReached(size)) {
                    return setShowStorageLimitReachedPopup(true);
                  }
                  if (size > 20000000) {
                    toast("File size exceeded 20MB", { type: "info" });
                  } else {
                    setMedia(file);
                  }
                }}
              />
            </label>
          )}
        </div>

        <button
          className="chat-screen-send"
          onClick={() => {
            // const formattedMessage = message.trim().replace(/\n/g, "&*&");
const formattedMessage = message;


            if (formattedMessage) onSend(formattedMessage);
            if (media) onMediaSend(media);

            resetMessage();
            resetMedia();
          }}
        >
          <img src={SendIcon} alt="Send" />
        </button>
      </div>
    </>
  );
};

export default ChatInput;
